import conf from "@/config.js"
import hr from "element-ui/src/locale/lang/hr";
import config from "@/config";
export default {
    filters: {
        formatYYmmdd(timestamp) {
            console.log("timestamp",timestamp)
            let time = '';
            if (timestamp.toString().length == 10) {
                time = new Date(timestamp * 1000);
            }
            else {
                time = new Date(timestamp);
            }
            const Y = time.getFullYear()
            const M = (time.getMonth() + 1).toString().padStart(2, '0')
            const D = time.getDate().toString().padStart(2, '0')
            const h = time.getHours().toString().padStart(2, '0')
            const m = time.getMinutes().toString().padStart(2, '0')
            const s = time.getSeconds().toString().padStart(2, '0')
            return `${Y}-${M}-${D} ${h}:${m}:${s}`
        },
        formatAppraise(val) {
            let str = '';
            switch (val*1) {
                case 0:
                    str = '不满意';
                    break;
                case 1:
                    str = '理解';
                    break;
                case 2:
                    str = '满意';
                    break;
                case 3:
                    str = '非常满意'
                    break;
                default:
                    str = ''
            }
            return str;
        }
    },
    methods: {
        /**
		 * 获取url后面的参数
		 * @param {*} name 参数名
		 */
		getUrlParams(name) {
			return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [,
				""
			])[
				1].replace(/\+/g, '%20')) || null
		},
        /**
         * 如果登陆的话获取用户 信息
         * 未登录 跳转登陆页面
         * @param {*} callback
         */
        getUserInfo(callback) {

        //     let href = window.location.href
        //     let index = href.lastIndexOf("?")
        //     let params =href.substring(index,href.length);

        //    if( params == '?code=szxx'){
        //        href = href.replace('orderSubmit?code=szxx',"szxx");
        //     }

        //     let signInUrl = conf.casAddress + "login?service=" + conf.baseApi + "/checkLogin" + "?redirectUrl=" + href
            this.axios.get("/getUserInfo").then((res) => {
                console.log(res);
                if (res.status == 200) {
                    if (res.data.code == 401) {
                        this.getSignUrl();
                        callback(res.data)
                        // this.$alert( '<div style="text-indent:2em;">西安12345政务服务便民热线网络诉求渠道依托省政务服务网进行统一身份认证，网民朋友注册成功，并通过身份认证后，即可在西安市人民政府官方网站和政务服务网实现“一网通办”。</div>','温馨提示:', {
                        //     confirmButtonText: '身份认证',
                        //     showClose:false,
                        //     dangerouslyUseHTMLString:true,
                        //     confirmButtonClass:"",
                        //     customClass:"auth-message-box",
                        //     callback: action => {
                        //         window.location.href = signInUrl
                        //     }
                        //   });

                    } else if (res.data.code == 200) {
                        console.log(222222);
                        localStorage.setItem('orderType1','1')
                        this.$store.commit('isLogin','1')
                        callback(res.data)
                    }
                } else {

                }
            });
        },

        getUserInfoNew(code,callback){
            this.newAxios.get("/api/getUserInfo",{params:{code:code}}).then(res =>{
                console.log(res,'1111111111');
                if (res.data.code == 200) {
                    localStorage.setItem('orderType1','1')
                    localStorage.setItem('yw_token',res.data.data.yw_token)
                    this.$store.commit('isLogin','1')
                    callback(res.data)
                }
            })
        },
        gwCommunication(api,params,telephone,callback){
            const data = {
                api:'api/v1'+api,
                data:params,
                telephone:telephone
            }
            this.newAxios.post('/orderApi/pushToOrder',data).then(res => {
                callback(res)
            })
        },

        /**
         * 生成重定向url，并且跳转
         */
        // getSignUrl(){
        //     let href = window.location.href
        //     let index = href.lastIndexOf("?")
        //     let params =href.substring(index,href.length);
        //     console.log(params);
        //     if( params == '?code=szxx'){
        //        href = href.replace('orderSubmit?code=szxx',"szxx");
        //     }
        //     let signInUrl = conf.casAddress + "login?service=" + conf.baseApi + "/checkLogin" + "?redirectUrl=" + href
        //
        //     this.$alert( '<div style="text-indent:2em;">西安12345政务服务便民热线网络诉求渠道依托省政务服务网进行统一身份认证，网民朋友注册成功，并通过身份认证后，即可在西安市人民政府官方网站和政务服务网实现“一网通办”。</div>','温馨提示:', {
        //         confirmButtonText: '身份认证',
        //         showClose:true,
        //         dangerouslyUseHTMLString:true,
        //         confirmButtonClass:"",
        //         customClass:"auth-message-box",
        //         // callback: action => {
        //         //     window.location.href = signInUrl
        //         // }
        //       })
        //         .then(() => {
        //         // this.$message({
        //         //     type: 'info',
        //         //     message: '保存修改'
        //         // });
        //         window.location.href = signInUrl
        //     })
        //         .catch(() => {
        //             this.$message({
        //                 type: 'info',
        //                 message: '停留在当前页面'
        //             })
        //         });
        // },
        getDomain(){
            let href = window.location.href
            let index = href.lastIndexOf("?")
            let params =href.substring(index,href.length);
            let params1 =href.substring(index,href.length-1);
            // console.log(params2);
            console.log(params);
             if(params1 == '?orderType='){
                let a =href.split('?')
                href=a[0]
                let orderType = a[1].split('=')
                localStorage.setItem('orderType',orderType[1])
            }
            return href;
        },
        getSignUrl(){
            let href = this.getDomain();
            let page = this.getUrlParams("orderPage");
            let order = this.getUrlParams("order");
            let orderNo = this.getUrlParams("orderNo");
            if(href.indexOf("?") != -1){
                href =href.substring(0,href.lastIndexOf("?"));
            }
            if(page){
                href = href + "?orderPage="+page;
            }
            //保留工单编号参数，登录回调后还能定位到详情
            if(order){
                href = href + (href.indexOf("?") != -1 ? "&" : "?") + "order=" + order;
            }
            if(orderNo){
                href = href + (href.indexOf("?") != -1 ? "&" : "?") + "orderNo=" + orderNo;
            }
            console.log("getSignUrl",href);
            //切换单点登录地址
            //let signInUrl = conf.casAddress + "login?service=" + conf.baseApi + "/checkLogin" + "?redirectUrl=" + href
            let signInUrl = conf.ssoLogin + '/sysauthserver/authorize?authCheck=true&needAuth=true&client_id='+conf.client_id+'&redirect_uri='+href
            this.$alert( '<div style="text-indent:2em;">西安12345政务服务便民热线网络诉求渠道依托省政务服务网进行统一身份认证，网民朋友注册成功，并通过身份认证后，即可在西安市人民政府官方网站和政务服务网实现“一网通办”。</div>','温馨提示:', {
                confirmButtonText: '身份认证',
                showClose:true,
                dangerouslyUseHTMLString:true,
                confirmButtonClass:"",
                customClass:"auth-message-box",
                // callback: action => {
                //     window.location.href = signInUrl
                // }
            })
                .then(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '保存修改'
                    // });
                    console.log(signInUrl);
                    window.location.href = signInUrl
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '停留在当前页面'
                    })
                });
        },
        login(){
            let href = window.location.href;
            let page = this.getUrlParams('orderPage');
            let order = this.getUrlParams('order');
            let orderNo = this.getUrlParams('orderNo');
            if(href.indexOf("?") != -1){
                href = href.substring(0,window.location.href.lastIndexOf("?"))
            }
            if(page){
                href = href + '?orderPage=' + page;
            }
            //保留工单编号参数，登录回调后还能定位到详情
            if(order){
                href = href + (href.indexOf("?") != -1 ? "&" : "?") + "order=" + order;
            }
            if(orderNo){
                href = href + (href.indexOf("?") != -1 ? "&" : "?") + "orderNo=" + orderNo;
            }
            console.log("window.location.href",href);
            //获取授权码
            let url =config.ssoLogin+'/sysauthserver/authorize?response_type=code&client_id='+config.client_id+'&redirect_uri='+href;
            window.location.href = url;
        },
        /**
        * generateUUID 生成UUID
        * @returns {string} 返回字符串
        */
        generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
            });
            return uuid;
        },
        /**
         * 根据时间戳 获取当前时间
         * @param {*} timestamp
         *
         * return  	2021/02/20 21:18:15
         */
        formatDateTime(timestamp) {
            if(!timestamp) return ''
            let time = '';
            if (timestamp.toString().length == 10) {
                time = new Date(timestamp * 1000);
            }
            else {
                time = new Date(timestamp);
            }
            const Y = time.getFullYear()
            const M = (time.getMonth() + 1).toString().padStart(2, '0')
            const D = time.getDate().toString().padStart(2, '0')
            const h = time.getHours().toString().padStart(2, '0')
            const m = time.getMinutes().toString().padStart(2, '0')
            const s = time.getSeconds().toString().padStart(2, '0')
            return `${Y}-${M}-${D} ${h}:${m}:${s}`
        },
        dateFormat2(fmt, date) {
            var o = {
              "M+": date.getMonth() + 1, //月份
              "d+": date.getDate(), //日
              "h+": date.getHours(), //小时
              "m+": date.getMinutes(), //分
              "s+": date.getSeconds(), //秒
              "q+": Math.floor((date.getMonth() + 3) / 3), //季度
              S: date.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt))
              fmt = fmt.replace(
                RegExp.$1,
                (date.getFullYear() + "").substr(4 - RegExp.$1.length)
              );
            for (var k in o)
              if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(
                  RegExp.$1,
                  RegExp.$1.length == 1
                    ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length)
                );
            return fmt;
          },
        /**
         * 格式化状态
         * @param {} state
         */
        formatState(state) {
            let value = "新事务";
            switch (state) {
                case 0: case 1: case 5:
                    value = "新事务" //暂存||新工单||分转岗退回
                    break;
                case 2: case 3: case 6: case 8: case 9:
                    value = "处理中"   //待接收||处理中||退回||重办||逾期
                    break;
                case 4: value = "待评价"   //待回访
                    break;
                case 7: case 99: value = "已归档"  //待归档||已归档
                    break;
            }
            return value;
        },
        getOrderTypeList(callback) {
			webAxios.get("/system/order_type/list", {
				params: {
					flag: false
				}
			}).then(res => {
				if (res.data.code == 200) {
                    callback(res.data.data)
				}
			}).catch(err => {
				console.log("获取工单类型失败：",err)
			})
		}
    }
}
